import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const Docs: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 29.3332V2.6665h24v19.2133c0 .7067-.28 1.3734-.7867 1.88l-4.7866 4.7867c-.4934.5067-1.1734.7867-1.88.7867H4Zm21.6-6.6667c.3733 0 .6667-.2933.6667-.6667V4.39984H5.73333V27.5998H20.6667c.3733 0 .6666-.2933.6666-.6666v-4.2667H25.6Zm-1.6-16h-6.6667v1.73334H24V6.6665Zm0 6.6668H8v1.7333h16v-1.7333Zm-16 4h16v1.7333H8v-1.7333Zm9.3333 4H8v1.7333h9.3333v-1.7333Z"
      clipRule="evenodd"
    />
  </Icon>
);
